import * as React from "react"
import * as styles from "./styles.module.scss"
import callToActionVideo from "./video/call-to-action.mp4"
import Button from "../../Button"

const CallToAction: React.FC = () => {
  return (
    <section className={styles.callToAction}>
      <div className={styles.pagePadding}>
        <video className={styles.video} autoPlay muted playsInline loop>
          <source src={callToActionVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className={styles.message}>
          <h3 className={styles.heading}>
            Get your Solar Roof to pay for itself
          </h3>
        </div>
        <div className={styles.actions}>
          <Button
            type="primary"
            size="lg"
            halo={true}
            href="https://www.better.com/api/leads?lead[sourceName]=Tesla"
            target="_self"
          >
            Get Started
          </Button>
        </div>
      </div>
    </section>
  )
}

export default CallToAction
